import { forwardRef, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { StarRounded } from "@mui/icons-material";

import { Box, Slide, Stack, Tooltip, Typography } from "@mui/material";

import styles from './index.module.scss';

import { useFetchPoints } from "../../../hooks/useFetchPoints";
import { AwardsContext } from "../../../context/AwardsContext";

const DialogAchievements = () => {
    const { t } = useTranslation('gamification');
    const { totalPoints, trigger: triggerFetchPoints } = useFetchPoints();

    const [starIconClasses, setStarIconClasses] = useState(`${styles.unanimated}`);
    const [pointsClasses, setPointsClasses] = useState(`${styles.hidePoints}`);
    const [pointsContainerClasses, setPointsContainerClasses] = useState(``);
    const [shouldPulse, setShouldPulse] = useState(false);

    const { showPoints, hidePointsAnimation, setModalToOpen } = useContext(AwardsContext);

    const animateAwardPointsIn = () => {
        setStarIconClasses(`${styles.animated} animating`);
        animateAwardPointsInButton();
    };

    const animateAwardPointsOut = () => {
        setStarIconClasses(`${styles.unanimated}`);
    };

    const animateAwardPointsInButton = () => {
        setPointsClasses(`${styles.showPoints}`);
        setPointsContainerClasses(`${styles.pointsContainer}`);
    };

    const animateAwardPointsOutButton = () => {
        setPointsClasses(`${styles.hidePoints}`);
        setPointsContainerClasses(``);
    };

    useEffect(() => {
        // Start pulsing animation on page load
        setShouldPulse(true);
        
        return () => {
            setShouldPulse(false);
        };
    }, []);

    useEffect(() => {
        // Start pulsing animation on page load
        setShouldPulse(true);
        
        return () => {
            setShouldPulse(false);
        };
    }, []);

    useEffect(() => {
        let timeout;

        if (showPoints) {
            animateAwardPointsIn();
            animateAwardPointsInButton();
            triggerFetchPoints();

            timeout = setTimeout(() => {
                animateAwardPointsOutButton();
                animateAwardPointsOut();
                hidePointsAnimation();
            }, 3000);
        }

        return () => {
            clearTimeout(timeout);
        }
        return () => {
            clearTimeout(timeout);
        }
    }, [showPoints]);

    return (
        <Box
            className='no-print'
        >
            <a
                href="#"
                onClick={(event) => {
                    event.preventDefault();
                    setModalToOpen('my-achievements');
                }}
            >
                <Stack
                    className={pointsContainerClasses}
                    direction={'row'}
                    alignItems={'center'}
                    justifyContent={'center'}
                    sx={{
                        color: '#000',
                        borderRadius: '2rem',
                        width: pointsContainerClasses ? 'auto' : '2rem',
                        transition: 'width 2s ease-in-out',
                    }}
                >
                    <Tooltip title={t('achievementsTooltip')}>
                        <Box
                            className={`${starIconClasses} ${shouldPulse ? styles.pulseGlowAnimation : ''}`}
                            sx={{
                                height: '2rem',
                                width: '2rem',
                                borderRadius: '50%',
                            }}
                        >
                            <StarRounded
                                sx={{
                                    ml: 'auto',
                                    fontSize: 32,
                                    color: !pointsContainerClasses ? '#f7ac16' : '#fff',
                                }}
                            />
                        </Box>
                    </Tooltip>
                    <Box
                        className={pointsClasses}
                        sx={{}}
                    >
                        <Typography
                            sx={{
                                fontWeight: 'bold',
                                fontSize: '1rem',
                                textAlign: 'center',
                                pb: 0.25,
                                color: '#f7ac16',
                            }}
                        >
                            {totalPoints}
                        </Typography>
                    </Box>
                </Stack>
            </a>
        </Box>
    )
}

export default DialogAchievements;